<template>
	<div>
		<Top flag="5"></Top>
		<div class="wd-container">
			<div class="goodslist wd-flex wd-row-left wd-flex-wrap">
				<div class="goods wd-flex wd-row-between" v-for="(item,index) in wddatalist" :key="index"  @click="gotogoodsdetail(item.goodsid,item.goodsname)">
					<div class="wd-width-100 wd-row-noshrink">
						<el-image class="wd-width-percent-100" :src="$wdpicurl(item.pic1)"></el-image>
					</div>
					<div class="wd-row-grow wd-m-l-20"> 
						<div class="name wd-line-2" >{{item.goodsname}}</div>
						<div class="retailprice"><span>零售价：</span><span class="wd-font-delete wd-theme-999">¥{{item.retailprice|amountFormatter}}</span></div>
						<div class="integral">
							<span>换购价：</span>
							<span class="wd-theme">{{item.integralexchange|numberFormatter}}积分</span>
							<span class="wd-theme wd-m-l-5" v-if="item.integralmoney>0">+{{item.integralmoney|amountFormatter}}元</span>
						</div>
						<div class="btn wd-flex wd-row-between wd-m-r-20"><span>{{item.salenum}}人换购</span><el-button plain type="primary">立即换购</el-button></div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
import Top from '@/components/layout/Top.vue';
import Footer from '@/components/layout/Footer.vue';
export default {
	name: 'IntegralMall',
	components: {
		Top,
		Footer
	},
	data() {
		return {
			wddatalist: []
		};
	},
	methods: {
		loaddata() {
			this.$wd_request('goodslist', { contype: 18 }).then(data => {
				this.wddatalist = data.value;
			});
		},
		gotogoodsdetail(goodsid, goodsname) {
			this.$router.push({
				name: 'Goodsinfo',
				query: {
					goodsid: goodsid,
					goodsname: goodsname,
					flag:1
				}
			});
		}
	},
	created() {
		this.loaddata();
	}
};
</script>

<style lang="scss" scoped>
	.goodslist{
		
		width: 100%;
		.goods{
			padding: 10px;
			margin-right: 10px;
			width: 371px;
			border: 1px solid $wd-border;
			margin-top: 10px;
			&:nth-child(3n){
				margin-right: 0;
			}
			.name{
				margin: 10px 0;
				height: 36px;
				line-height: 18px;
			}
			.retailprice{
				margin: 10px 0;
			}
			.integral{
				margin: 10px 0;
			}
			&:hover {
				cursor: pointer;
				box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);//基础投影 
			}
		}
	}
</style>
